import {
	OfferProductResponse,
	PagedOfferProductResponse,
} from '@Modules/offers/application/dtos/PagedOfferProductResponse'
import { OfferProduct, PagedOfferProduct } from '@Modules/offers/domain/entities/offerProduct'
import { mapFromPagedResponseToPagingData, TranslatorFunction } from 'ufinet-web-functions'

const offerProductSerViceTypeNameAdapter = (
	serviceTypeName: string | undefined | null,
	translate: TranslatorFunction
): string => {
	switch (serviceTypeName) {
		case 'ETHERNET':
			return translate('SERVICE.TECHNOLOGY.TYPE.ETHERNET')
		default:
			return serviceTypeName ?? ''
	}
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const offerNameHandler = (offerProduct: OfferProductResponse, translate: TranslatorFunction): string => {
	let offerName = `${translate(`SERVICE.TECHNOLOGY.${offerProduct.serviceTypeName}`)} `

	switch (offerProduct.serviceTypeName) {
		case 'CAPACIDAD_ID':
			offerName += `${offerProductSerViceTypeNameAdapter(offerProduct.technologyCapacityName, translate)} ${
				offerProduct.bandwidth
			} ${offerProduct.unitsName}`
			break

		case 'INTERNET_ID':
			offerName += `${offerProduct.accessTypeInternetName} ${offerProduct.bandwidth} ${offerProduct.unitsName}`
			break

		case 'TOWERING_ID':
			offerName += `${translate(`SERVICE.TOWERING.STRUCTURE_TYPES.${offerProduct.toweringStructureTypeName}`)} ${
				offerProduct.structureHeight
			}m`
			break

		case 'COLOCATION_ID':
			offerName += [
				translate(`SERVICE.COLLOCATION.EMPLACEMENT_TYPES.${offerProduct.emplacementTypeName}`),
				offerProduct.collocationQuantity,
				translate(`SERVICE.COLLOCATION.COLLOCATION_UNITS.${offerProduct.collocationUnitName}`),
			].join(' ')
			break

		case 'FIBRA_OSCURA_ID': {
			const fiberNumberSuffix = offerProduct.fiberNumber === 1 ? '' : 'S'
			const fiberNumberTranslation = translate(`SERVICE.DARK_FIBER.THREAD${fiberNumberSuffix}`)
			offerName += offerProduct.fiberNumber + ` ${fiberNumberTranslation}`
			break
		}

		default:
			break
	}

	return offerName
}

export const offerProductsPagedMapper = (
	pagedOfferProductsResponse: PagedOfferProductResponse,
	translate: TranslatorFunction
): PagedOfferProduct => {
	return {
		pagingData: mapFromPagedResponseToPagingData(pagedOfferProductsResponse),
		offerProducts: pagedOfferProductsResponse.data.map((offerProduct: OfferProductResponse): OfferProduct => {
			return {
				id: offerProduct.id,
				offerUid: offerProduct.offerUid,
				serviceTypeId: offerProduct.serviceTypeId,
				serviceTypeName: offerProduct.serviceTypeName,
				bandwidth: offerProduct.bandwidth,
				unitsld: offerProduct.unitsld,
				unitsName: offerProduct.unitsName,
				accessTypeInternetId: offerProduct.accessTypeInternetId,
				accessTypeInternetName: offerProduct.accessTypeInternetName,
				technologyCapacityId: offerProduct.technologyCapacityId,
				technologyCapacityName: offerProduct.technologyCapacityName,
				nrc: offerProduct.nrc,
				mrc: offerProduct.mrc,
				currencyId: offerProduct.currencyId,
				currencyName: offerProduct.currencyName,
				period: offerProduct.period,
				origin: offerProduct.origin,
				destination: offerProduct.destination,
				generatedBacklog: offerProduct.generatedBacklog,
				toweringStructureTypeName: offerProduct.toweringStructureTypeName,
				toweringStructureTypeId: offerProduct.toweringStructureTypeId,
				structureHeight: offerProduct.structureHeight,
				emplacementTypeId: offerProduct.emplacementTypeId,
				emplacementTypeName: offerProduct.emplacementTypeName,
				collocationQuantity: offerProduct.collocationQuantity,
				collocationUnitId: offerProduct.collocationUnitId,
				collocationUnitName: offerProduct.collocationUnitName,
				fiberNumber: offerProduct.fiberNumber,
				name: offerProduct.name,
				aqsVan: offerProduct.aqsVan,
				ingVan: offerProduct.ingVan,
				aqsCalculationStatus: offerProduct.aqsCalculationStatus,
				aqsCalculationStatusName: offerProduct.aqsCalculationStatusName
					? translate(`CALCULATION_STATE.${offerProduct.aqsCalculationStatusName}`)
					: null,
			}
		}),
	}
}
